(function () {
    'use strict';

    angular.module('Directives').directive('bbaProfileManagerPostcodes', bbaProfileManagerPostcodes);

    bbaProfileManagerPostcodes.$inject = [
        '$q',
        'Location'
    ];

    function bbaProfileManagerPostcodes($q,
                                        Location) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/bba-profile-manager/bba-profile-manager-postcodes.html',
            scope: {
                step: '=',
                isViewMode: '=?',
                init: '=',
                disabled: '='
            },
            controller: bbaProfileManagerPostcodesController,
            controllerAs: 'vm',
            bindToController: true
        };
        
        function bbaProfileManagerPostcodesController($scope) {

            let vm = this;

            vm.onSelectCountry = onSelectCountry;
            vm.searchPostcodes = searchPostcodes;
            vm.onSelectPostcode = onSelectPostcode;
            vm.addSuburb = addSuburb;
            vm.addAllSuburbs = addAllSuburbs;
            vm.removeSuburb = removeSuburb;

            init();

            $scope.$watch(angular.bind(this, () => this.init), value => {
                if (value) init();
            });

            function init() {
                vm.postcodesRaw = vm.step.details[vm.step.postcodesField + 's'];
                vm.postcodes = angular.copy(vm.postcodesRaw);
                vm.postcodeIds = vm.postcodesRaw.map(postcode => postcode.id);
                vm.countries = [];
                vm.country = vm.postcodesRaw[0] && vm.postcodesRaw[0].country || null;
                vm.selectedPostcode = null;
                vm.selectedSuburb = null;
                initCountries();
            }


            function initCountries() {
                Location.Country({}, function (data) {
                    vm.countries = data;
                }, function (err) {
                    toastr.error('Unable to get countries', err.message);
                });
            }

            function onSelectCountry(country) {
                if (!country) {
                    vm.postcodes = [];
                } else {
                    vm.postcodes = vm.postcodesRaw.filter(code => (code.country && code.country.code) === country.code);
                    vm.step.details[vm.step.postcodesField + 's'] = vm.postcodes;
                }
            }

            function searchPostcodes(select, country) {
                vm.postcodeOptions = [];
                if (!select.open) {
                    return false;
                }
                vm.searching = true;
                const defer = $q.defer();
                Location.City({
                    country,
                    code: select.search || undefined,
                    enabled: true,
                    sort: 'code',
                    size: 200
                }, function (data) {
                    vm.suburbs = data.filter(postcode => vm.postcodeIds.indexOf(postcode.id) < 0);
                    vm.postcodeOptions = vm.suburbs.map(postcode => postcode.code || '(No Postcode)');
                    vm.postcodeOptions = vm.postcodeOptions.filter((code, i) => vm.postcodeOptions.indexOf(code) === i);
                    vm.searching = false;
                }, function (err) {
                    vm.searching = false;
                    defer.reject(err);
                });
                return defer.promise;
            }

            function onSelectPostcode() {
                vm.suburbOptions = vm.selectedPostcode ? vm.suburbs.filter(suburb => suburb.code === vm.selectedPostcode) : [];
                vm.suburbOptions.sort((a, b) => ((a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0)));
                vm.selectedSuburb = vm.suburbOptions[0];
            }

            function addSuburb() {
                vm.postcodesRaw.push(vm.selectedSuburb);
                vm.postcodeIds.push(vm.selectedSuburb.id);
                vm.suburbOptions = vm.suburbOptions.filter(suburb => suburb.id !== vm.selectedSuburb.id);
                if (!vm.suburbOptions.length) {
                    vm.selectedSuburb = null;
                    vm.selectedPostcode = null;
                } else {
                    vm.selectedSuburb = vm.suburbOptions[0];
                }
                onSelectCountry(vm.country);
            }

            function addAllSuburbs() {
                vm.postcodesRaw = [...vm.postcodesRaw, ...vm.suburbOptions];
                vm.postcodeIds = [...vm.postcodeIds, ...vm.suburbOptions.map(suburb => suburb.id)];
                vm.suburbOptions = [];
                vm.selectedSuburb = null;
                vm.selectedPostcode = null;
                onSelectCountry(vm.country);
            }

            function removeSuburb(suburb) {
                vm.postcodesRaw = vm.postcodesRaw.filter(postcode => postcode.id !== suburb.id);
                vm.postcodeIds = vm.postcodeIds.filter(id => id !== suburb.id);
                if (vm.selectedPostcode && vm.selectedPostcode === suburb.code) {
                    vm.suburbOptions.push(suburb);
                    vm.selectedSuburb = suburb;
                }
                onSelectCountry(vm.country);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaProfileManagerPostcodes.js